'use client';

import React from 'react';
import * as FaIcons from 'react-icons/fa6';

interface IconDisplayProps {
  iconName?: string;
  size?: number;
  className?: string;
  defaultIcon?: string;
}

/**
 * A reusable component to display FA6 icons from a string name
 *
 * @param iconName - The name of the FA6 icon (e.g., "FaUser")
 * @param size - The size of the icon in pixels
 * @param className - Additional CSS classes to apply to the icon
 * @param defaultIcon - The default icon to display if iconName is not provided or invalid
 */
export default function IconDisplay({
  iconName,
  size = 20,
  className = '',
  defaultIcon = 'FaUser',
}: IconDisplayProps) {
  // Get the icon component from the icon name
  let IconComponent;

  if (iconName && FaIcons[iconName as keyof typeof FaIcons]) {
    IconComponent = FaIcons[iconName as keyof typeof FaIcons];
  } else if (defaultIcon && FaIcons[defaultIcon as keyof typeof FaIcons]) {
    IconComponent = FaIcons[defaultIcon as keyof typeof FaIcons];
  } else {
    IconComponent = FaIcons.FaUser; // Fallback to FaUser if both are invalid
  }

  return <IconComponent size={size} className={className} />;
}
